@if (signatureOverview) {
  <p-card>
    <div class="grid">
      <div class="col-12">
        <cross-signatures
          [(signatures)]="signatures"
          [signatureRemovable]="true"
          (signaturesChange)="checkSignaturesComplete()">
        </cross-signatures>
      </div>
      <div class="col-12 text-right">
        <app-button [disabled]="!signaturesComplete"
                    [busy]="busy"
                    (onClick)="updateSignatures()">
        </app-button>
      </div>
    </div>
  </p-card>
}
